/**
 * FIDS IntelligenceMetric — a labelled data row for opportunity briefing cards
 * and dossiers. Optional accent icon and semantic tone.
 */
export const IntelligenceMetric = ({
  icon: Icon,
  label,
  value,
  tone = "neutral",
  testId,
  align = "row",
}) => {
  const toneText = {
    neutral: "text-ink-900",
    intel: "text-intel-700",
    opportunity: "text-opportunity-600",
    warning: "text-warning-600",
    risk: "text-risk-600",
  }[tone];

  if (align === "stack") {
    return (
      <div
        data-testid={testId}
        className="rounded-lg border border-surface-200 bg-white p-4"
      >
        <div className="flex items-center gap-2">
          {Icon && (
            <Icon
              className="h-3.5 w-3.5 text-ink-500"
              strokeWidth={1.75}
              aria-hidden
            />
          )}
          <span className="text-[11px] font-medium uppercase tracking-wider text-ink-500">
            {label}
          </span>
        </div>
        <div className={`mt-1.5 text-sm font-semibold ${toneText}`}>{value}</div>
      </div>
    );
  }

  return (
    <div
      data-testid={testId}
      className="flex items-center justify-between gap-4 rounded-lg border border-surface-200 bg-white px-4 py-3"
    >
      <span className="inline-flex items-center gap-2 text-sm text-ink-500">
        {Icon && (
          <Icon className="h-4 w-4 text-ink-500" strokeWidth={1.75} aria-hidden />
        )}
        {label}
      </span>
      <span className={`text-sm font-semibold ${toneText}`}>{value}</span>
    </div>
  );
};
